/**
 * @description In order to upload files from Vue, we need to either use a FormData object of encode the image as base64. 
 * Base64 isn't the best because of it's size, so using this allows us to upload data from Vue along with an image Blob.
 * 
 * 
 * @param {Object} obj Object to be converted into FormData
 * @param {String} rootName Where to start the conversion
 * @param {Array} ignoreList Properties in the object that should not be converted
 * 
 * @returns {FormData}
 */

export default function objectToFormData(obj, rootName, ignoreList) {
    var formData = new FormData();

    function appendFormData(data, root) {
        if (!ignore(root)) {
            root = root || '';
            if (data instanceof File || data instanceof Blob) {
                formData.append(root, data);
            } else if (Array.isArray(data)) {
                for (var i = 0; i < data.length; i++) {
                    appendFormData(data[i], root + '[' + i + ']');
                }
            } else if (typeof (data) === 'object' && data) {
                for (var key in data) {
                    if (data.hasOwnProperty(key)) {
                        if (root === '') {
                            appendFormData(data[key], key);
                        } else {
                            appendFormData(data[key], `${root}[${key}]`);
                        }
                    }
                }
            } else if (typeof data === 'boolean' && data) {
                /**
                 * Booleans need to be converted to 1 || 0 otherwise they're sent as a string
                 */
                formData.append(root, (data) ? 1 : 0);
            } else {
                if (data !== null && typeof data !== 'undefined') {
                    formData.append(root, data);
                }
            }
        }
    }

    function ignore(root) {
        return Array.isArray(ignoreList)
            && ignoreList.some(function (x) { return x === root; });
    }

    appendFormData(obj, rootName);

    return formData;
}